/**
 * Created by mauget on 2/29/16.
 */

// NotificationsFailedView.js

import $ from 'jquery';
import _ from 'lodash';
import Immutable from 'immutable';

import { View } from 'backbone';

import DashboardModel   from 'DashboardModel.js';
import constants        from 'Constants.js';
import util from 'util/Util.js';
import RestService from 'RestService.js';
import NotificationService from 'NotificationService.js';
import eventBus  from 'EventBus.js';
import contentTemplate  from 'dashboard/notifications/failed-view.ejs';



class NotificationsFailedView extends View {

    initialize( opts ) {

        this.options = opts || {};
        this.gridEl = constants.PROP_MAIN_TABLE;
        this.template = contentTemplate;
        this.formSet=Immutable.Set();
        this.serverSet=Immutable.Set();
        this.dateSet=Immutable.Set();
        this.reasonSet=Immutable.Set();

        this.events={
            'change select' : 'performFilter',
            'change input[type=text]' : 'performFilter',
            'click  button[id=fRetry] ' : 'performRetryNotifications', 
            'click #goToNotifications': 'goToNotifications'
        };

        this.model.set({
            colModel: [
                {
                    name: 'formName',
                    index: 'formName'
                },
                {
                    name: 'instanceName',
                    index: 'instanceName'
                },
                {
                    name: 'notificationSubject',
                    index: 'notificationSubject'
                },
                {
                    name: 'notificationEmailId',
                    index: 'notificationEmailId'
                },
                {
                    name: 'notificationServer',
                    index: 'notificationServer'
                },
                {
                    name: 'notificationDateAndTime',
                    index: 'notificationDateAndTime'
                },
                {
                    name: 'reasonForFailure',
                    index: 'reasonForFailure'
                }
            ],
            colNames: [
                'App Name',
                'Instance Name',
                'Notification Subject',
                'Notification Email Id',
                'Notification Server',
                'Notification Date and Time',
                'Reason for Failure'
            ]
        }, {silent: true});
        this.onResize();


        this.initializeFilters();

        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    initializeFilters(){
        let gridData=this.model.get('filteredGridData');
        if(gridData){
            gridData.forEach((notification)=>{
                this.formSet=this.formSet.add(notification['@FormName']);
                this.serverSet=this.serverSet.add(notification['@Address']);
                this.dateSet=this.dateSet.add(notification['@NotificationDate']);
                this.reasonSet=this.reasonSet.add(notification['@FailureReason']);
            });
        }
        this.model.set('fForm','any');
        this.model.set('fReason','any');
        this.model.set('fLabel','any');
        this.model.set('fDate','any');
        this.model.set('fSubject','');
    }

    performFilter(ev){

        this.model.set(ev.currentTarget.name,ev.currentTarget.value,{silent:true});
        let currentFormFilter=this.model.get('fForm');
        let currentServerFilter=this.model.get('fLabel');
        let currentDateFilter=this.model.get('fDate');
        let currentSubjectFilter=this.model.get('fSubject');
        let currentReasonFilter=this.model.get('fReason');
        let currentGridData=this.model.get('gridData');
        this.model.set('filteredGridData',Object.assign([],currentGridData),{silent:true});

        if(currentFormFilter !== 'any'){
            currentGridData=this.filterByCriteria(currentGridData,"@FormName",currentFormFilter);
        }
        if(currentServerFilter !== 'any'){
            currentGridData=this.filterByCriteria(currentGridData,"@Address",currentServerFilter);
        }
        if(currentDateFilter !== 'any'){
            currentGridData=this.filterByCriteria(currentGridData,"@NotificationDate",currentDateFilter);
        }
        if(currentReasonFilter !== 'any'){
            currentGridData=this.filterByCriteria(currentGridData,"@FailureReason",currentReasonFilter);
        }
        if(currentSubjectFilter !== ''){
            currentGridData=this.filterByCriteria(currentGridData,"@Subject",currentSubjectFilter);
        }

        this.model.set('filteredGridData',currentGridData,{silent:true});
        this.render();
    }

    performRetryNotifications(ev){
        // Grab Current Selected Rows
        let selectedRows=$(this.gridEl).jqGrid("getGridParam","selarrrow");
        let selectedEmailIds=[];

        // Perform API Call sending respective rows
        selectedRows.forEach((rowId)=>{
            selectedEmailIds.push($(this.gridEl).jqGrid("getLocalRow", rowId)["notificationEmailId"]);
        });

        // Formatting message for retrying email messages.
        let failedEmails=selectedEmailIds.length > 1 ? selectedEmailIds.join(',') : selectedEmailIds[0];

        //Perform API Call to Refresh data from failed notifications
        RestService.retryFailedEmails(failedEmails).then((result)=>{
            eventBus.trigger(constants.EV_RELOAD_FAILED_NOTIFICATIONS,undefined,true);
        }).catch((err=>{
            console.log('Error Retrying Failed Email Notifications: ',err);
            NotificationService.error('Error Retrying Failed Email Notifications: '+err.MESSAGE);
        }));
    }

    filterByCriteria(data,criteria,value){
        return data.filter((row)=>{
            return row[criteria] === value;
        })
    }

    // Listening on the resize event of the window to call the resizeGrid method on the parent an adapt the grid.
    onResize(){
        $(window).bind('resize',() => {this.resizeGrid();})
    }

    // Method that renders an scroll in the grid in order to navigate the same on small screens.
    resizeGrid(){
        let grid = $('.ui-jqgrid-btable');
        if (grid) {
            grid.each(function(index) {
                let gridId = $(this).attr('id');
                let gridParentWidth = $('#gbox_' + gridId).parent().width();
                $('#' + gridId).setGridWidth(gridParentWidth);
            });
        }
    }

    renderGrid(){
        let self = this;
        let itemsToRender=this.model.get('filteredGridData');
        let gridObject = util.getGridObject(this,{autowidth:true,height:400,scrollOffset:0,multiselect:true,cellEdit:false});
        $(this.gridEl).jqGrid(gridObject);
        _.forEach(itemsToRender, (field, index) => {
            self.fillNewRow(index, field['@FormName'], field['@InstanceName'],field['@Title'],field['@EMailID'],field['@Address'],field['@NotificationDate'],field['@FailureReason'])
        });
    }

    fillNewRow(index, formName, instanceName,title,emailId,address,notificationDate,failureMessage) {
        $(this.gridEl).addRowData(index, {
            'formName':formName,
            'instanceName':instanceName,
            'notificationSubject':title,
            'notificationEmailId':emailId,
            'notificationServer':address,
            'notificationDateAndTime':notificationDate,
            'reasonForFailure':failureMessage
        });
    }

    onSelectRow(){
        this.checkRetryNotificationButton();
    }

    onCellSelect(){}

    setRow(rowId, e){
    }

    fillFilter(selector,setToFilter,filterToSelect){
        let formSelect=$(selector);
        setToFilter.map((val)=>{
            formSelect.append($("<option></option>")
                .attr('value', val)
                .text(val));
        });
        formSelect.find(`option[value="${filterToSelect}"]`).prop('selected',true);
    }

    checkRetryNotificationButton(){
        let selectedRows=$(this.gridEl).jqGrid("getGridParam","selarrrow");
        if(selectedRows.length === 0){
            $("button[id=fRetry]").prop('disabled',true);
        }
        else{
            $("button[id=fRetry]").prop('disabled',false);
        }
    }

    render() {
        this.$el.empty();
        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }


        this.renderGrid();

        this.fillFilter('#fForm',this.formSet,this.model.get('fForm'));
        this.fillFilter('#fLabel',this.serverSet,this.model.get('fLabel'));
        this.fillFilter('#fDate',this.dateSet,this.model.get('fDate'));
        this.fillFilter('#fReason',this.reasonSet,this.model.get('fReason'));
        this.checkRetryNotificationButton();

        this.delegateEvents();
        this.$el.css( 'cursor', 'default' );

        return this;
    }

    refresh(){
        let notificationId=this.model.get('notificationDetails').NotificationId;
        eventBus.trigger(constants.EV_REFRESH_FAILED_NOTIFICATIONS_DASHBOARD,notificationId);
    }

    goToNotifications(e) {
         e.preventDefault();
         e.stopPropagation(); 

         eventBus.trigger('loadNotificationsView');
    }
}

export default NotificationsFailedView;

